import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Redirect  } from 'react-router-dom';
import { isLoaded, isEmpty } from 'react-redux-firebase';

const PrivateRoute = ({ component: Component, ...rest }) => {
    const { auth } = rest;
    return (<Route {...rest} render={props => (
            !isLoaded(auth) || isEmpty(auth)
            ? <Redirect to='/' /> 
            : <Component {...props} />
    )} />
    );
}

function mapStateToProps(state) {
    return {
        auth: state.firebaseReducer.auth,
    };
}

export default withRouter(connect(mapStateToProps)(PrivateRoute));